/* eslint-disable react/jsx-no-bind */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/jsx-props-no-spreading */
// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from 'react';
import { Badge, Tooltip } from 'antd';
import { BellOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

import controller, { NotificationRecord } from './controller';

import Popup from './components/popup';

import './index.less';

function NotificationCenter() {
  const [unread, setUnread] = useState(0);
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();

  const handleTriggerPopover = () => {
    setVisible(!visible);
  };

  useEffect(() => {
    const handleUpdate = (records: NotificationRecord[]) => {
      let newUnread = 0;

      records.forEach((record) => {
        if (record.readed === false) {
          newUnread += 1;
        }
      });
      setUnread(newUnread);
    };
    controller.on('update', handleUpdate);

    return () => {
      controller.off('update', handleUpdate);
    };
  }, []);

  useEffect(() => {
    const handleClosePopup = () => {
      setVisible(false);
    };

    document.addEventListener('click', handleClosePopup);
  }, []);

  return (
    <Popup visible={visible} onTrigger={handleTriggerPopover}>
      <div className="notification_center_container">
        <Tooltip overlay={t('navBar.notification')}>
          <Badge count={unread} size="small" overflowCount={99}>
            <BellOutlined style={{ fontSize: 20 }} />
          </Badge>
        </Tooltip>
      </div>
    </Popup>
  );
}

export default NotificationCenter;
